import { observer } from 'mobx-react';
import ActionButtons from './ActionButtons';

interface Props {
  onConfirm: () => void;
}

function Footer({ onConfirm }: Props) {
  return (
    <div className="border-t border-border bg-card py-4" data-intercom-target="share-invite-footer">
      <div className="max-w-5xl mx-auto px-12">
        <div className="flex items-center justify-between">
          <ActionButtons onConfirm={onConfirm} placement="bottom" />
        </div>
      </div>
    </div>
  );
}

export default observer(Footer);
